import { SyncStatusItem } from '../../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/ExternalUpdates'

import { hideDocumentSidebar } from '../../../store/processDocument/documentSidebar'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetMeQuery } from '../../../store/user/user'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { useDocumentSyncStatuses } from './hooks'

export const DocumentExternalUpdateSidebar = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const { data: currentUser = null } = useGetMeQuery({ accountId })

  const { syncStatuses } = useDocumentSyncStatuses()

  const handleHideSidebar = () => {
    dispatch(hideDocumentSidebar())
  }

  return (
    <div className='d-flex flex-column gap-2 zocks-py-1.25 zocks-px-1.25 h-100'>
      {!syncStatuses.length ? (
        <div className='d-flex flex-column h-100 justify-content-center align-items-center'>
          <h4>No updates yet</h4>
          <div className='text-center'>
            <div>The complete update history will appear here with direct access links.</div>
            <div>All in one place.</div>
          </div>
        </div>
      ) : null}
      {syncStatuses.map((syncStatus) => (
        <div key={`${syncStatus.serviceId}-${syncStatus.externalId}-${syncStatus.syncedAt}`}>
          <SyncStatusItem currentUser={currentUser} syncStatus={syncStatus} source='history' onHideSidebar={handleHideSidebar} />
        </div>
      ))}
    </div>
  )
}
